import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { UsersApi, type UpdatePasswordRequest } from '@shared/api';

const updatePasswordEffect = createEffect((request: UpdatePasswordRequest) => UsersApi.updatePassword(request));
const clearEvent = createEvent();

const $dataStore = createStore<boolean>(false)
  .on(updatePasswordEffect.done, (_, data) => data.result.success)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updatePasswordEffect.pending, (_, data) => data)
  .on(updatePasswordEffect.fail, () => false)
  .on(updatePasswordEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(updatePasswordEffect, () => null)
  .on(
    updatePasswordEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while changing Password. Please try again.').message,
  )
  .on(updatePasswordEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $userUpdatePasswordStore = {
  events: {
    updatePassword: updatePasswordEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
